import Button from '@sats-group/ui-lib/react/button';
import HiddenInput from '@sats-group/ui-lib/react/hidden-input/hidden-input';
import Info from '@sats-group/ui-lib/react/icons/18/info';
import Text from '@sats-group/ui-lib/react/text';
import React, { useState } from 'react';
import FlowLayout from '~/client/components/flow-layout/flow-layout';
import Spinner from '~/client/components/spinner/spinner';
import type { RenewEmployerChanged as Props } from './renew-employer-changed.types';

const RenewEmployerChanged: React.FC<Props> = ({ form, info, layout }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit: React.FormEventHandler = e => {
    if (isSubmitting) {
      e.preventDefault();
      return;
    }

    setIsSubmitting(true);
  };

  return (
    <FlowLayout {...layout}>
      {isSubmitting ? <Spinner theme={Spinner.themes.overlay} /> : null}
      <div className="renew-employer-changed">
        <div className="renew-employer-changed__content">
          <form
            action={form.endpoint}
            className="renew-employer-changed__form"
            method="POST"
            onSubmit={handleSubmit}
          >
            {form.data.map(input => (
              <HiddenInput key={input.name} {...input} />
            ))}
            <div className="renew-employer-changed__form-content">
              <Text theme={Text.themes.emphasis} size={Text.sizes.large}>
                {form.question}
              </Text>
              <Text>{form.text}</Text>
            </div>
            <Button
              {...form.submit}
              size={Button.sizes.basic}
              variant={Button.variants.primary}
              wide
            />
          </form>
        </div>
        <div className="renew-employer-changed__info">
          <div className="renew-employer-changed__icon">
            <Info />
          </div>
          <Text>{info}</Text>
        </div>
      </div>
    </FlowLayout>
  );
};

export default RenewEmployerChanged;
